import Component from '../abstracts/Component';

export default class SideButtons extends Component{
    get CLASSNAMES (){
        return {
            chatOff: 'chat-offline',
            hiddenBar: 'hidden',
        }
    }
    get SELECTORS (){
        return {
            chatMinimizedBtn : 'button.embeddedServiceSidebarMinimizedDefaultUI',
        }
    }
    constructor(targetEl){
        super();
        this.comp = targetEl;
        this.triggers = targetEl.querySelectorAll('[data-trigger-panel]') || [];
        this.chatBtns = targetEl.querySelectorAll('[data-chat-btn]') || [];
        this.embeddedSvc = window.embedded_svc || false;
        this.chatOn = false;
        this.connected = false;
        if(this.comp && this.triggers){
            this.init();
        }
    }
    init(){
        super.init();
        this.addChatBtnsListeners();
        this.addChatEmbeddedListeners();

    }
    getChatBtn(){
        let selector = '.embeddedServiceHelpButton > .helpButton > .uiButton';
        return document.querySelector(selector);
    }
    getChatMinimizedBtn (){
        return document.querySelector(this.SELECTORS.chatMinimizedBtn);
    }
    hideMinimizedBtn(bool){
        let btn = this.getChatMinimizedBtn();
        if(bool){
            btn.classList.add(this.CLASSNAMES.hiddenBar);
        }else{
            btn.classList.remove(this.CLASSNAMES.hiddenBar);
        }
    }
    addChatBtnsListeners(){
        console.log(this.chatBtns, typeof this.chatBtns);
        this.chatBtns.forEach(btn=> {
            btn.addEventListener('click',(e)=> {
//                let chatSFBtn = this.getChatBtn();
//                console.log(chatSFBtn)
//                if(chatSFBtn){
////                    console.log(chatSFBtn.classList);
//                    chatSFBtn.click();
//                }
                e.target.disabled = true;
                if(this.embeddedSvc){
                    if(!this.chatOn){
                        this.embeddedSvc.bootstrapEmbeddedService();
                        this.chatOn = true;
                    }else{
                        this.embeddedSvc.liveAgentAPI.startChat();
                    }

//                    this.hideSidebar(true);
                }
            });
        })
    }

    hideSidebar(bool){
        if(typeof bool === 'boolean' && bool){
            this.comp.classList.add(this.CLASSNAMES.hiddenBar);
        }else{
            this.comp.classList.remove(this.CLASSNAMES.hiddenBar);
        }
    }

    enableChatBtns() {
        this.chatBtns.forEach(btn => {
            btn.disabled = false;
        })
    }

    addChatEmbeddedListeners(){
        console.log('The embedded_svc  was loaded', this.embeddedSvc);

        this.$on(this.$events.CHAT.availability,(e,data)=>{
            if(data.isAgentAvailable){
                console.log('Agent available with id:', data.id);
                this.comp.classList.remove(this.CLASSNAMES.chatOff);
            }else{
                console.log('Agent Unavailable');
                this.comp.classList.add(this.CLASSNAMES.chatOff);
            }
        });
        this.$on(this.$events.CHAT.minimized,(e,data)=>{
            console.log('CHAT MINIMIZED')
//            if(!this.connected){
//                window.embedded_svc.liveAgentAPI.endChat();
//            }
            if(this.chatOn && !this.connected){
                this.hideMinimizedBtn(true);
            }
            this.enableChatBtns()
        })
        this.$on(this.$events.CHAT.req_success,(e,data)=>{
            console.log('CHAT Request success')
            this.connected = true;
            this.hideMinimizedBtn(false);
            this.hideSidebar(true);
        })
        this.$on(this.$events.CHAT.agent_join,(e,data)=>{
            console.log('CHAT Agent Join')
        })
        this.$on(this.$events.CHAT.established,(e,data)=>{
            console.log('CHAT Connection Established');
        })
        this.$on(this.$events.CHAT.endByUser,(e,data)=>{
            console.log('CHAT Connection Closed by User')
            this.enableChatBtns()
        })

        this.$on(this.$events.CHAT.destroyed,(e,data)=>{
            console.log('CHAT DESTROYED')
            this.chatOn = false;
            this.connected = false;
            this.hideSidebar(false);
            this.enableChatBtns()
        })

    }
}
